export default __webpack_public_path__ + "static/media/1149.11f80fee.png";